import React from 'react'
import Navbar from '../../components/Navbar';
import Dashboard from '../../components/Dashboard/index'
import Footer from '../../components/Footer';
import './styles.css'
import { Grid, styled } from '@mui/material';

const LandingPageWrapper = styled(Grid)`
    background: '#0000FF'
`;

function index() {
    return (
        <LandingPageWrapper>
            <Navbar />
            <Dashboard />
            <Footer />
        </LandingPageWrapper>
    )
}

export default index